export default function Footer() {
  const cols = [
    {
      title: "档案栏目",
      links: [
        { label: "深扒", href: "#channel" },
        { label: "人物起底", href: "#archive" },
        { label: "背景揭秘", href: "#channel" },
        { label: "内幕线索", href: "#timeline" },
      ],
    },
    {
      title: "检索视角",
      links: [
        { label: "热议榜", href: "#rank" },
        { label: "话题墙", href: "#topic" },
        { label: "档案馆合集", href: "#collection" },
        { label: "深扒长文", href: "#feature" },
      ],
    },
    {
      title: "关于本站",
      links: [
        { label: "本站怎么扒", href: "#about" },
        { label: "可信度分级", href: "#about" },
        { label: "勘误与申诉", href: "#about" },
        { label: "回到顶部", href: "#top" },
      ],
    },
  ];

  return (
    <footer className="border-t border-foreground-950/8 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-focus-3-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">网黑料</span>
            </a>
            <p className="mt-4 text-[13px] leading-6 text-foreground-600">
              专注人物黑历史深扒、起底与背景揭秘的检索档案站，内幕逐条标可信度，只做资料整理，不做情绪放大器。
            </p>
            <div className="mt-4 flex items-center gap-3">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-rss-line", label: "RSS" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-950/10 text-foreground-600 transition-colors hover:border-foreground-950/25 hover:text-foreground-950"
                >
                  <i className={s.icon + " text-base"} />
                </a>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-label text-xs tracking-[0.2em] text-foreground-500 uppercase">{c.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
                    >
                      {l.label}
                      <i className="ri-arrow-right-up-line text-xs text-foreground-300" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-foreground-950/8 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-foreground-500">
            © 2026 网黑料 · 人物黑历史深扒 / 人物起底 / 背景揭秘档案库
          </p>
          <p className="font-label text-xs text-foreground-500">
            本站内容仅作公开信息整理与背景分析，不代表对任何主体的定性结论；请理性看待，勿据单方言论做判断。
          </p>
        </div>
      </div>
    </footer>
  );
}